import axios from "axios";
import {
  isAuthenticated,
  getAccessToken,
  getRefreshToken,
  saveToken,
} from "./authentication.service";

import _ from "lodash";

import { refreshToken } from "../redux/actions/users";

import IdentityService from "./identity.service";
import AuthService from "./auth.service";

let isAlreadyFetchingAccessToken = false;
let subscribers = [];

const apiUrl = `${process.env.REACT_APP_API_URL}`;
const usersApiUrl = `${process.env.REACT_APP_USERS_API_URL}`;
const cleverstoryApiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const assetsApiUrl = process.env.REACT_APP_ASSETS_API_URL;
const dealRoomApiUrl = `${process.env.REACT_APP_DEAL_ROOM_API_URL}`;

const REGISTRATION_URL = `${usersApiUrl}/registrations`;
const FORGOT_PASSWORD_URL = `${usersApiUrl}/forgot-password`;
const coachingApiUrl = process.env.REACT_APP_COACHING_API_URL;
const OAUTH_URL = `${apiUrl}/oauth/token`;

export default function AuthInterceptor(hasLite) {
  axios.interceptors.request.use(function (config) {
    if (isAuthenticated()) {
      if (
        (
          config.url.startsWith(apiUrl) ||
          config.url.startsWith(usersApiUrl) ||
          config.url.startsWith(cleverstoryApiUrl) ||
          config.url.startsWith(coachingApiUrl) ||
          config.url.startsWith(dealRoomApiUrl) ||
          config.url.startsWith(assetsApiUrl)
        ) &&
        !config.url.startsWith(OAUTH_URL) &&
        !config.url.startsWith(REGISTRATION_URL) &&
        !config.url.startsWith(FORGOT_PASSWORD_URL)
      ) {
        config.headers.Authorization = "Bearer " + getAccessToken();
      }
    }

    if (config.url.startsWith(apiUrl)) {
      config.headers["PF-IDENTITY"] = IdentityService.getFingerprint();
      if (hasLite) {
        config.headers["PF-PLATFORM"] = "SALESFORCE_NATIVE";
        config.headers["PF-VERSION"] = "1.0.0";
      } else {
        config.headers["PF-PLATFORM"] = "WEB";
        config.headers["PF-VERSION"] = "1.0.0";
      }
    }

    return config;
  });

  //Intercept response and prepare the error object
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      const { config } = error;

      const status = _.get(error, "response.status", null);
      const originalRequest = config;

      if (status === 401) {
        if (
          config.url.endsWith("oauth/token") ||
          config.url.endsWith("users/logout") ||
          config.url.endsWith("users/change-password")
        ) {
          console.log("Refresh token has expired");
          return;
        }

        if (!isAlreadyFetchingAccessToken) {
          isAlreadyFetchingAccessToken = true;
          var refreshTokenValue = getRefreshToken();

          refreshToken(refreshTokenValue)
            .then((token) => {
              isAlreadyFetchingAccessToken = false;

              if (token && token.data && token.data.access_token) {
                saveToken(token.data.access_token, token.data.refresh_token);
                onAccessTokenFetched(token.data.access_token);
              }
            })
            .catch((err) => {
              AuthService.clearAccessToken();
              subscribers = [];
              console.log(err);
              window.location.href = "/public/login";
            });
        } 

        const retryOriginalRequest = new Promise((resolve) => {
          addSubscriber((access_token) => {
            originalRequest.headers.Authorization = "Bearer " + access_token;
            resolve(axios(originalRequest));
          });
        });

        return retryOriginalRequest;
      }

      console.log("Unknown error :" + error);
      if (error.response && error.response.data) {
        return Promise.reject(error.response.data);
      } else {
        return Promise.reject({
          code: "99999",
          message: "Oops, Unable to complete the request",
        });
      }
    },
  );
}

function onAccessTokenFetched(access_token) {
  subscribers = subscribers.filter((callback) => callback(access_token));
}

function addSubscriber(callback) {
  subscribers.push(callback);
}
